<!-- Backdrop -->
<!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
<button class="modal-backdrop" (click)="onBackdropClick()"></button>

<!-- Modal content -->
<div class="fixed top-1/2 left-1/2 z-50 min-w-80 -translate-x-1/2 -translate-y-1/2 rounded-sm bg-white p-8">
  @if (title) {
    <h3 class="mt-0">{{ title }}</h3>
  }

  <div>
    <p class="text-gray-700">{{ message }}</p>
  </div>

  <div class="mt-4 flex justify-center gap-4">
    @if (isConfirm) {
      <button (click)="onConfirm()" class="btn btn-primary justify-center min-w-[126px]">{{ confirmButtonText }}</button>
      <button (click)="onCancel()" class="btn btn-secondary justify-center min-w-[126px]">{{ cancelButtonText }}</button>
    } @else {
      <button (click)="onClose()" class="btn btn-secondary justify-center min-w-[126px]">{{ closeButtonText }}</button>
    }
  </div>
</div>
